'use client';

import { useState, useEffect } from 'react';

interface PasswordModalProps {
    children: React.ReactNode;
}

const FIVE_MINUTES = 60 * 60 * 1000;

const PasswordModal: React.FC<PasswordModalProps> = ({ children }) => {
    const [authorized, setAuthorized] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const access = localStorage.getItem('blog-access');
        const accessTime = localStorage.getItem('blog-access-time');

        if (access === 'granted' && accessTime) {
            const elapsed = Date.now() - parseInt(accessTime, 10);
            if (elapsed < FIVE_MINUTES) {
                setAuthorized(true);
            } else {
                localStorage.removeItem('blog-access');
                localStorage.removeItem('blog-access-time');
                setAuthorized(false);
            }
        }
    }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (password === 'TEST-123') {
            localStorage.setItem('blog-access', 'granted');
            localStorage.setItem('blog-access-time', Date.now().toString());
            setAuthorized(true);
            setError('');
        } else {
            setError('Şifre yanlış!');
        }
    };

    if (authorized) {
        return <>{children}</>;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <form
                onSubmit={handleSubmit}
                className="bg-white  dark:bg-black border border-dark/10 dark:border-white/10 rounded-2xl p-8 shadow-lg w-96"
            >
                <div className="flex flex-col gap-8">
                    <h2 className="text-xl font-semibold mb-4">Şifre Gerekli</h2>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Şifre || TEST-123"
                        className="px-6 py-3.5 border border-black/10 dark:border-white/10 rounded-full outline-primary focus:outline"
                    />
                    {error && <p className="text-red-600 mb-2">{error}</p>}
                    <button
                        type="submit"
                        className="px-8 py-4 rounded-full bg-primary text-white text-base font-semibold w-full mobile:w-fit hover:cursor-pointer hover:bg-dark duration-300"
                    >
                        Giriş Yap
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PasswordModal;
